import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaitosuratcab() {



  const cardData =
  {
    keyword: 'Mumbai to Surat Cab ',
    heading: 'Shambhu Cabs: Mumbai to Surat Cab  ',
    headingDescription: 'Shambhu Cabs offers reliable Mumbai to Surat Cab services, providing safe, comfortable, and hassle-free travel for families, business travelers, groups, and corporate clients commuting between Mumbai and Surat. Our fleet of hatchbacks, sedans, SUVs, and tempo travellers ensures a smooth and pleasant journey with well-maintained vehicles and spacious seating. With flexible one-way and round-trip options, professional chauffeurs, and 24/7 booking support, Shambhu Cabs makes long-distance travel convenient and worry-free. From South Mumbai to Thane, Andheri to Navi Mumbai, Shambhu Cabs provides doorstep pickup and trusted Mumbai to Surat cab services for travelers seeking comfort, safety, punctuality, and a reliable intercity travel experience.',

    top: 'Top Places to Visit in Surat with Shambhu Cabs',

 
"topPlaces": [
  {
    "title": "Surat Castle (Old Fort)",
    "description": "Surat Castle, also known as the Old Fort, was built in the 16th century by Sultan Mahmud III to protect the city from Portuguese attacks. The massive stone walls, grand battlements, and strategic placement along the Tapi River showcase the fort's importance during the Mughal and colonial eras. Visitors can explore its ancient architecture, climb its ramparts, and observe panoramic views of the riverside. The fort stands as a proud historical structure reflecting Surat’s strategic military past."
  },
  {
    "title": "Sardar Patel Museum",
    "description": "Established in 1890, the Sardar Patel Museum is one of Gujarat’s oldest museums and a major cultural treasure of Surat. It houses rare manuscripts, ancient coins, Mughal-era artifacts, sculptures, paintings, and tribal art collections. Visitors can explore audio-visual galleries, cultural exhibits, and a planetarium inside the museum complex. Its diverse collection offers a fascinating glimpse into Gujarat’s art, culture, scientific growth, and history."
  },
  {
    "title": "Dutch Garden",
    "description": "Dutch Garden is a beautifully landscaped colonial-era garden located along the Tapi River. It is named after the cemetery of Dutch and Armenian traders who lived in Surat during the 17th and 18th centuries. The garden features old tombs, lush greenery, stone pathways, and riverfront views, offering a serene blend of history and nature. It is a peaceful place for evening walks, photography, and understanding Surat’s early global trade connections."
  },
  {
    "title": "Dumas Beach",
    "description": "Dumas Beach is one of Surat’s most famous attractions, known for its black sand and breezy Arabian Sea coastline. The beach becomes especially lively during evenings, with food stalls serving local delicacies like tomato bhajiya, sweet corn, and pav bhaji. Visitors enjoy long walks, stunning sunsets, and the cool sea breeze. The mystique of the black sand and the tranquil atmosphere make it a must-visit coastal destination near the city."
  },
  {
    "title": "Gopi Talav",
    "description": "Originally built in the 16th century by Malik Gopi, a wealthy merchant credited with developing parts of modern Surat, Gopi Talav is now a beautifully restored lakefront destination. The complex includes gardens, boating facilities, children’s play areas, fountains, and themed zones. Illuminated in the evenings, the lake offers a peaceful environment for families and tourists. It is a perfect blend of history, leisure, and scenic beauty."
  },
  {
    "title": "VR Mall Surat",
    "description": "VR Mall is Surat’s largest lifestyle destination, offering a premium shopping, dining, and entertainment experience. With national and international brands, a multiplex cinema, gaming arcade, and diverse restaurants, the mall attracts both locals and tourists. The vibrant décor and the regular cultural events hosted here make it a modern hotspot in the city."
  },
  {
    "title": "Sarthana Nature Park & Zoo",
    "description": "Sarthana Nature Park is one of Gujarat’s largest zoological parks, spread across lush green landscapes perfect for nature lovers and families. It houses tigers, lions, deer, reptiles, and various exotic birds. The well-maintained paths and natural surroundings offer a relaxing experience, making it an ideal place for wildlife enthusiasts, photography lovers, and school groups."
  },
  {
    "title": "Iscon Mall",
    "description": "Iscon Mall is a popular shopping and entertainment hub in Surat known for its vibrant atmosphere and diverse retail options. Visitors can explore clothing stores, cafes, restaurants, and a multiplex cinema. The mall is a favorite hangout spot for youngsters and families looking to spend an enjoyable evening indoors."
  },
  {
    "title": "Ambika Niketan Temple",
    "description": "Dedicated to Goddess Ambika, this temple holds deep spiritual significance for the people of Surat. Built in 1969, it is located along the banks of the Tapi River and attracts thousands of devotees every week. The peaceful environment, traditional architecture, and the scenic riverbank make it a serene spot for prayer and relaxation."
  },
  {
    "title": "Science Centre Surat",
    "description": "The Science Centre is an educational and recreational complex featuring a science museum, art gallery, planetarium, and amusement areas. The engaging exhibits explain scientific concepts in interactive ways, making it highly popular among students and families. From 3D shows to hands-on experiments, the centre provides a fun-filled learning experience."
  }
],




"services": [
  {
    "name": "Mumbai Surat Taxi",
    "description": "Mumbai Surat Taxi offers reliable, comfortable, and fast intercity travel for passengers commuting between Mumbai and Surat. With expert drivers, clean vehicles, and seamless expressway travel, this service is ideal for business trips, family travel, medical visits, and leisure journeys. Passengers enjoy doorstep pickup, flexible scheduling, and transparent pricing for a smooth long-distance travel experience."
  },
  {
    "name": "Surat Cab from Mumbai",
    "description": "Surat Cab from Mumbai provides convenient and dependable cab services for travelers heading directly from any location in Mumbai to Surat. Featuring multiple car options, verified chauffeurs, and timely pickups, this service caters to tourists, corporate travelers, and families. The journey ensures comfort, safety, and efficiency, making travel between both cities hassle-free."
  },
  {
    "name": "One-Way Cab Mumbai Surat",
    "description": "One-Way Cab Mumbai Surat is designed for travelers who only need a one-direction ride without return charges. This economical option includes clean sedans, spacious SUVs, and premium cars driven by experienced chauffeurs familiar with the Mumbai–Surat highway route. Ideal for relocations, office travel, hotel check-ins, personal journeys, or emergency trips."
  },
  {
    "name": "Affordable Cab Mumbai Surat",
    "description": "Affordable Cab Mumbai Surat offers cost-effective intercity taxi services without compromising on comfort or safety. This budget-friendly option includes well-maintained vehicles, polite drivers, and transparent fares. Perfect for frequent travelers, families, and students looking for low-cost yet reliable transportation to Surat."
  },
  {
    "name": "Best Taxi Mumbai Surat",
    "description": "Best Taxi Mumbai Surat ensures a top-quality travel experience with superior vehicles, excellent driver professionalism, and on-time pickup. The service is suitable for premium travel needs, ensuring comfort throughout the journey. Passengers can expect smooth expressway driving, clean interiors, and a safe, enjoyable ride from Mumbai to Surat."
  },
  {
    "name": "SUV Cab Mumbai Surat",
    "description": "SUV Cab Mumbai Surat provides spacious, powerful vehicles ideal for group travel, family trips, and long-distance comfort. Featuring large legroom, smooth suspension, and additional luggage space, SUV cabs ensure maximum comfort. Skilled drivers handle expressway and highway routes efficiently, offering a stable and enjoyable journey."
  },
  {
    "name": "Sedan Cab Mumbai Surat",
    "description": "Sedan Cab Mumbai Surat is perfect for travelers who prefer a comfortable, fuel-efficient, and budget-friendly ride. Sedans offer smooth performance, air-conditioned comfort, and excellent mileage, making them ideal for solo travelers, couples, and business passengers seeking cost-effective long-distance travel."
  },
  {
    "name": "Outstation Cab Mumbai Surat",
    "description": "Outstation Cab Mumbai Surat provides dedicated long-distance travel with flexible booking options including one-way, round trip, and multi-day rentals. Suitable for leisure, business, and family travel, this service includes experienced long-route drivers, well-kept vehicles, and complete travel convenience."
  },
  {
    "name": "24×7 Mumbai Surat Taxi",
    "description": "24×7 Mumbai Surat Taxi ensures round-the-clock cab availability for urgent, late-night, early-morning, or pre-scheduled travel. With fast response times and dependable drivers, passengers can book a cab anytime for smooth intercity travel. Ideal for emergencies, airport pickups, and unplanned trips."
  },
  {
    "name": "Corporate Cab Mumbai Surat",
    "description": "Corporate Cab Mumbai Surat is designed for business professionals and companies requiring premium cab services for intercity travel. With punctual pickups, trained chauffeurs, and premium vehicles, this service supports corporate mobility needs, client travel, and executive transfers with the highest standards."
  },
  {
    "name": "Fast Cab Mumbai Surat",
    "description": "Fast Cab Mumbai Surat focuses on quickest possible travel with skilled drivers, efficient highway navigation, and minimal stoppages. Ideal for travelers who need to reach Surat urgently for meetings, business requirements, or personal commitments. Safety and speed are balanced for optimal travel."
  },
  {
    "name": "Premium Cab Mumbai Surat",
    "description": "Premium Cab Mumbai Surat offers luxury travel with high-end sedans and SUVs equipped with plush interiors, powerful air conditioning, and smooth ride quality. This service ensures maximum comfort, making it ideal for special occasions, VIP travel, business executives, and luxury seekers traveling between Mumbai and Surat."
  },
  {
    "name": "Safe Taxi Mumbai Surat",
    "description": "Safe Taxi Mumbai Surat prioritizes passenger safety with verified drivers, sanitized vehicles, GPS tracking, and secure travel practices. Perfect for women travelers, senior citizens, families, and solo passengers, this service ensures a peaceful and stress-free ride from Mumbai to Surat."
  },
  {
    "name": "Mumbai Surat Pickup Drop",
    "description": "Mumbai Surat Pickup Drop offers convenient point-to-point transfers from any location in Mumbai—homes, offices, hotels, or airports—to any destination in Surat. With flexible timings and professional drivers, the service ensures smooth and timely travel for all trip purposes."
  },
  {
    "name": "Express Highway Cab Surat",
    "description": "Express Highway Cab Surat is optimized for fast and smooth travel via the Mumbai–Surat express and highway routes. Drivers trained for long-distance expressway travel ensure quick transit while maintaining complete safety. Perfect for time-sensitive journeys and fast business transfers."
  },
  {
    "name": "Family Cab Mumbai Surat",
    "description": "Family Cab Mumbai Surat offers spacious, comfortable, and secure cabs ideal for family travel. With child-friendly seating, large luggage space, and courteous drivers, this service ensures a safe and relaxing journey for families heading to Surat for holidays, festivals, or personal trips."
  },
  {
    "name": "Long Route Cab Mumbai Surat",
    "description": "Long Route Cab Mumbai Surat is designed for extended journeys with comfortable seating, well-maintained vehicles, and long-distance trained drivers. This service is perfect for passengers needing a smooth, uninterrupted long-hour drive between Mumbai and Surat. Ideal for leisure, business, and relocation travel."
  }
],

"tableData": [
  ["Mumbai Surat Taxi", "Surat Cab from Mumbai"],
  ["One-Way Cab Mumbai Surat", "Affordable Cab Mumbai Surat"],
  ["Best Taxi Mumbai Surat", "SUV Cab Mumbai Surat"],
  ["Sedan Cab Mumbai Surat", "Outstation Cab Mumbai Surat"],
  ["24×7 Mumbai Surat Taxi", "Corporate Cab Mumbai Surat"],
  ["Fast Cab Mumbai Surat", "Premium Cab Mumbai Surat"],
  ["Safe Taxi Mumbai Surat", "Mumbai Surat Pickup Drop"],
  ["Express Highway Cab Surat", "Family Cab Mumbai Surat"],
  ["Long Route Cab Mumbai Surat", "—"]
],


"whychoose": [
  {
    "WhyChooseheading": "Mumbai to Surat Cab with Shambhu Cabs",
    "WhyChoosedescription": "Shambhu Cabs offers reliable Mumbai to Surat cab services, perfect for business travel, family trips, and comfortable intercity journeys."
  },
  {
    "WhyChooseheading": "Comfortable and Well-Maintained Vehicles",
    "WhyChoosedescription": "Travel in spacious, air-conditioned, and regularly maintained cabs to ensure a smooth and relaxing journey to Surat."
  },
  {
    "WhyChooseheading": "Experienced Drivers for Highway Routes",
    "WhyChoosedescription": "Our professional drivers are well-versed with the Mumbai to Surat highway route, ensuring safe, timely, and hassle-free travel."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Enjoy clear and upfront pricing—fuel, tolls, and driver allowances included—making your Mumbai to Surat cab trip worry-free."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our dedicated support team is available round the clock to assist with bookings, travel queries, and real-time route guidance."
  },
  {
    "WhyChooseheading": "Flexible Rental Plans for Outstation Travel",
    "WhyChoosedescription": "Choose from one-way, round-trip, or customized rental plans designed to suit your Mumbai to Surat travel requirements."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All cabs are thoroughly cleaned and sanitized before every journey, ensuring a hygienic and safe travel experience."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "We provide punctual pickups and smooth service, making your Mumbai to Surat journey comfortable and stress-free."
  }
]


























  }

const faqData = [
  {
    question: 'Does Shambhu Cabs offer Mumbai to Surat cab services?',
    answer: 'Yes, Shambhu Cabs provides reliable and comfortable Mumbai to Surat cab services with professional and experienced drivers.',
  },
  {
    question: 'How can I book a Mumbai to Surat cab with Shambhu Cabs?',
    answer: 'You can easily book through our website, mobile app, or by contacting our 24x7 customer support team for instant assistance.',
  },
  {
    question: 'What types of vehicles are available for Mumbai to Surat cab bookings?',
    answer: 'Shambhu Cabs offers well-maintained sedans, SUVs, and luxury cars suitable for a smooth and comfortable journey from Mumbai to Surat.',
  },
  {
    question: 'Are drivers experienced for the Mumbai to Surat route?',
    answer: 'Yes, our drivers are licensed, trained, and familiar with the Mumbai to Surat highway route to ensure a safe and efficient journey.',
  },
  {
    question: 'Can I choose custom pickup and drop-off locations for my Mumbai to Surat cab?',
    answer: 'Absolutely. You can select any preferred pickup location in Mumbai and choose a drop-off point anywhere in Surat.',
  },
  {
    question: 'Is the Mumbai to Surat cab service available 24x7 with Shambhu Cabs?',
    answer: 'Yes, Shambhu Cabs provides round-the-clock Mumbai to Surat cab booking services to fit your travel needs.',
  },
  {
    question: 'Are safety and hygiene measures followed for Mumbai to Surat cab bookings?',
    answer: 'All vehicles are sanitized regularly, and our drivers follow strict hygiene and safety protocols throughout the journey.',
  },
  {
    question: 'What payment options are available for Mumbai to Surat cab bookings?',
    answer: 'We accept UPI, digital wallets, credit/debit cards, bank transfers, and corporate account billing.',
  },
  {
    question: 'Is customer support available during the Mumbai to Surat trip?',
    answer: 'Yes, our 24x7 customer support team is available to assist you throughout your Mumbai to Surat travel.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Vipul Shah',
    feedback: 'Our Mumbai to Surat trip with Shambhu Cabs was very comfortable. The driver was professional and the car was clean.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Rima Patel',
    feedback: 'Highly reliable Mumbai to Surat cab service. Smooth journey, timely pickup, and excellent support from Shambhu Cabs.',
    rating: 5,
  },
];

















































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "mumbai-outstation-cabs" },
    { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "mumbai-to-mahabaleshwar-cab" },
    { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "mumbai-to-goa-cabs" },
    { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "mumbai-to-shirdi-cab" },
    { place: "/images/keyword/5.jpg", text: "Mumbai Nashik Cab", link: "mumbai-nashik-cab" },
    { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "mumbai-to-kolhapur-cab" },
    { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "mumbai-to-pune-cab" },
    { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "mumbai-to-aurangabad-cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "mumbai-to-bhimashankar-cab" },
    { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "mumbai-to-ashtavinayak-cab-service" },
    { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "mumbai-to-5-jyotirlinga-cab" },
    { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "mumbai-to-lonavala-cab" },
    { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "mumbai-to-konkan-darshan-cab-booking" },
    { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "mumbai-to-alibaug-cab" },
    { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "mumbai-to-ahmednagar-cab" },
    { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran Cab", link: "mumbai-to-matheran-cab" },
    { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon / Dhule Cab", link: "mumbai-to-jalgaon-dhule-cab" },
    { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "mumbai-to-lavasa-cab" },
    { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "mumbai-to-panchgani-cab" },
    { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "mumbai-to-khandala-taxi-fare" },
    { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "mumbai-to-surat-cab" },
    { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "mumbai-to-ahmedabad-cab" },
    { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "mumbai-to-narmada-parikrama-cab-booking" },
    { place: "/images/keyword/24.jpg", text: "Mumbai to Vadodara Cab", link: "mumbai-to-vadodara-cab" },
    { place: "/images/keyword/25.jpg", text: "Mumbai to Daman Taxi", link: "mumbai-to-daman-taxi" },
  ];






const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Surat Cab",
  "image": "https://www.shambhucab.com/assets/images/mumbai-to-surat-cab.jpg",
  "description": "Shambhu Cabs provides safe and reliable Mumbai to Surat cab services for one-way and round trips. Book sedans, SUVs, or premium cars for family trips, corporate travel, and long-distance journeys. Enjoy affordable, fast, and 24×7 taxi service with professional drivers and express highway options.",
  "brand": {
    "@type": "Brand",
    "name": "Shambhu Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "5300",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "7000",
    "availability": "https://schema.org/InStock",
    "url": "https://www.shambhucab.com/mumbai-to-surat-cab"
  }
};







  return (
    <div>
<Helmet>
  <title>Mumbai to Surat Cab | Outstation & Corporate Taxi | Shambhu Cabs</title>

  <meta
    name="description"
    content="Book Mumbai to Surat cab with Shambhu Cabs. Safe, affordable, and comfortable taxi service for one-way and round trips, family travel, corporate travel, and long-distance journeys. Available 24×7 with sedan, SUV, and premium cars."
  />

  <meta
    name="keywords"
    content="Mumbai Surat Taxi, Surat Cab from Mumbai, One-Way Cab Mumbai Surat, Affordable Cab Mumbai Surat, Best Taxi Mumbai Surat, SUV Cab Mumbai Surat, Sedan Cab Mumbai Surat, Outstation Cab Mumbai Surat, 24×7 Mumbai Surat Taxi, Corporate Cab Mumbai Surat, Fast Cab Mumbai Surat, Premium Cab Mumbai Surat, Safe Taxi Mumbai Surat, Mumbai Surat Pickup Drop, Express Highway Cab Surat, Family Cab Mumbai Surat, Long Route Cab Mumbai Surat"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
      <section className="gauto-breadcromb-area section_70">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="breadcromb-box">
                <h3> {cardData.keyword}</h3>
              </div>
            </div>
          </div>
        </div>
      </section>







      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/19.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

            

              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Shambhu Cabs</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shambhu Cabs </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919819399797" className="pc-call">+91 9819399797</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919819399797"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919819399797" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@shambhucab.com" className="pc-email">
                      booking@shambhucab.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Shambhu Cabs</strong><br />
                      Saket Tata Power CHS, Swami Samarth Marg,
                      Juhu Nagar, Sector-16, Vashi, Navi Mumbai,
                      Maharashtra India - 400703
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaitosuratcab;